<template>
  <div id="showBankTransfer" class="block paymentDetails">
    <div class="BankTransfer-info">
      <span class="BankTransfer-info_title"><b>Bank Details</b></span>
      <div v-html="bankDetailsDesc"></div>
      <div class="BankTransfer-wrap">
        <div class="payment-modal-object">
          <h4>Account Name</h4>
          <span>{{ propBankAct.bankAccName }}</span>
        </div>
        <div class="payment-modal-object">
          <h4>Account Number</h4>
          <span>{{ bankActNo }}</span>
        </div>
        <div class="payment-modal-object">
          <h4>Bank Name</h4>
          <span>{{ propBankAct.bankName }}</span>
        </div>
        <div class="payment-modal-object" v-if="!propIsDbsVA">
          <h4>Bank Branch</h4>
          <span>{{ propBankAct.bankBranch }}</span>
        </div>
        <div class="payment-modal-object" v-if="!propIsDbsVA">
          <h4>Bank Code</h4>
          <span>{{ propBankAct.bankCode }}</span>
        </div>
        <div class="payment-modal-object" v-if="!propIsDbsVA">
          <h4>Branch Code</h4>
          <span>{{ propBankAct.bankBranchCode }}</span>
        </div>
        <div class="payment-modal-object">
          <h4>Swift Code</h4>
          <span>{{ propBankAct.bankSwiftCode }}</span>
        </div>
        <div class="payment-modal-object" v-if="propIsDbsVA">
          <h4>Address of Beneficiary Bank</h4>
          <span>{{ propBankAct.bankAddress }}</span>
        </div>
        <div class="payment-modal-object" v-if="propIsDbsVA">
          <h4>Country</h4>
          <span>{{ propBankAct.bankCountry }}</span>
        </div>
      </div>

      <hr />
      <div class="BankTransfer-wrap" v-if="propIsJapanSchool">
        <div class="payment-modal-object">
          <h4>Account Name</h4>
          <span>{{ bankAct2.bankAccName2 }}</span>
        </div>
        <div class="payment-modal-object">
          <h4>Account Number</h4>
          <span>{{ bankAct2.bankAccNO2 }}</span>
        </div>
        <div class="payment-modal-object">
          <h4>Bank Name</h4>
          <span>{{ bankAct2.bankName2 }}</span>
        </div>
        <div class="payment-modal-object">
          <h4>Bank Branch</h4>
          <span>{{ bankAct2.bankBranch2 }}</span>
        </div>
        <div class="payment-modal-object">
          <h4>Bank Code</h4>
          <span>{{ bankAct2.bankCode2 }}</span>
        </div>
        <div class="payment-modal-object">
          <h4>Branch Code</h4>
          <span>{{ bankAct2.bankBranchCode2 }}</span>
        </div>
        <div class="payment-modal-object">
          <h4>Swift Code</h4>
          <span>{{ bankAct2.bankSwiftCode2 }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaymentBankDetails',
  props: ['propIsBankTransfer', 'propIsJapanSchool', 'propBankAct', 'propIsDbsVA', 'propStudentInfo'],
  data() {
    return {
      bankAct2: {
        bankAccName2: 'JIA Co., LTD',
        bankAccNO2: '8555060 Futsu',
        bankName2: 'Sumitomo Mitsui Banking Corporation',
        bankBranch2: 'Hibiya Branch',
        bankCode2: '0009',
        bankBranchCode2: '632',
        bankSwiftCode2: 'SMBCJPJT',
      },
      bankActNo: '',
      bankDetailsDesc: '**Please kindly indicate the invoice numbers clearly when making payments so as to assist our payment tracking. Thank you.',
    }
  },
  mounted() {
    this.bankActNo = this.propBankAct.bankAccNO
    if (this.propIsDbsVA) {
      this.bankDetailsDesc = `<strong>Do note that the ${this.propBankAct?.bankAccNO?.length} digits Account Number reflected below is unique to each student.</strong> Please refrain from making payment to our generic bank account number. Thank you.`
    }
  },
}
</script>
